// extracted by mini-css-extract-plugin
module.exports = {"baseSectionMessage":"baseSectionMessage--1rkyc","message":"message--wZNXG","button":"button--ZBf+v"};